module.exports = __webpack_public_path__ + "img/map-down.394803d4.svg";